import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Catalogs|Achievements|Logic|';

const sharedData: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.CredentialAchievements,
};

export type SPAchievementLogicLocs =
	| 'SPAchievementLogicSectionTitle'
	| 'SPAchievementLogicHeading'
	| 'SPAchievementLogicFolderOpened'
	| 'SPAchievementLogicFolderClosed'
	| 'SPAchievementLogicForever'
	| 'SPAchievementLogicMonths'
	| 'SPAchievementLogicDuration'
	| 'SPAchievementLogicRequired';

export const spAchievementLogicLocs: LocDefs<SPAchievementLogicLocs> = {
	SPAchievementLogicSectionTitle: {
		defaultValue: 'Logic',
		description: 'Page section title.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Logic.Title.Page',
		displayPath: `${dpRoot}Page Section Title`,
		displayType: 'Title',
		...sharedData,
	},
	SPAchievementLogicHeading: {
		defaultValue: 'Achievements Catalog',
		description: 'Page heading.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Logic.Title.Heading',
		displayPath: `${dpRoot}Page Heading`,
		displayType: 'Title',
		...sharedData,
	},
	SPAchievementLogicFolderOpened: {
		defaultValue: 'Close Folder',
		description: 'Tooltip for the button to close the folder.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Logic.Button.FolderOpened',
		displayPath: `${dpRoot}Folder Opened`,
		displayType: 'Button',
		...sharedData,
	},
	SPAchievementLogicFolderClosed: {
		defaultValue: 'Open Folder',
		description: 'Tooltip for the button to open the folder.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Logic.Button.FolderClosed',
		displayPath: `${dpRoot}Folder Closed`,
		displayType: 'Button',
		...sharedData,
	},
	SPAchievementLogicForever: {
		defaultValue: 'Forever',
		description: 'Content for "Forever" in the achievement logic.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Logic.Content.Forever',
		displayPath: `${dpRoot}Forever`,
		displayType: 'Content',
		...sharedData,
	},
	SPAchievementLogicMonths: {
		defaultValue: 'Months',
		description: 'Content for "Months" in the achievement logic.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Logic.Content.Months',
		displayPath: `${dpRoot}Months`,
		displayType: 'Content',
		...sharedData,
	},
	SPAchievementLogicDuration: {
		defaultValue: 'Active For',
		description: 'Content for "Active For" in the achievement logic.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Logic.Content.Duration',
		displayPath: `${dpRoot}Active For`,
		displayType: 'Content',
		...sharedData,
	},
	SPAchievementLogicRequired: {
		defaultValue: 'Required',
		description: 'Content for "Required" in the achievement logic.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.Logic.Content.Required',
		displayPath: `${dpRoot}Required`,
		displayType: 'Content',
		...sharedData,
	},
};

export type SPAchievementLogicLocKeys = LocMap<SPAchievementLogicLocs>;

export const spAchievementLogicLocKeys: SPAchievementLogicLocKeys =
	MapLocKeys<SPAchievementLogicLocs>(spAchievementLogicLocs);
